import React, { Component } from 'react';
import MonthPicker from './MonthPicker';
import 'react-month-picker/css/month-picker.css';
import Select from 'react-select';
import { PdfButton, XlsxButton } from './Buttons';

export default class MitarbeiterUebersichtFilter extends Component {
    render() {
        return (
            <React.Fragment>
                <div className="row">
                    <div className="col-xl-2">
                        <div className="align-items-center row">
                            <label className="col-xl-3 col-form-label">Start</label>
                            <div className="col-xl-7">
                                <MonthPicker
                                    value={this.props.startDate}
                                    onChange={this.props.onStartDateChange}
                                    minValue={this.props.minDate}
                                    maxValue={this.props.maxDate}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="col-xl-2">
                        <div className="align-items-center row">
                            <label className="col-xl-3 col-form-label">Ende</label>
                            <div className="col-xl-7">
                                <MonthPicker
                                    value={this.props.endDate}
                                    onChange={this.props.onEndDateChange}
                                    minValue={this.props.minDate}
                                    maxValue={this.props.maxDate}
                                />
                            </div>
                        </div>
                    </div>
                    {this.props.mitarbeiters.length > 1 && (
                        <div className="col-xl-4">
                            <div className="form-group mb-0 row">
                                <label className="col-xl-3 text-xl-center text-lg-left col-form-label">Mitarbeiter</label>
                                <div className="col-xl-9">
                                    <Select
                                        options={this.props.mitarbeiters}
                                        value={this.props.mitarbeiters.find(mitarbeiter => mitarbeiter.value == this.props.selectedMitarbeiterId)}
                                        onChange={this.props.onMitarbeiterChange}
                                        isMulti={false}
                                    />
                                </div>
                            </div>
                        </div>
                    )}
                    <div className="col-auto mt-3 mt-lg-3 mt-xl-0 ml-auto">
                        <PdfButton onClick={this.props.onPdfButtonClick} />
                        <XlsxButton onClick={this.props.onXlsxButtonClick} />
                    </div>
                </div>
            </React.Fragment>
        );
    }
}
